"use client";

import { CustomButton, FlexCenter, FlexCol } from "@/components";
import InputDataContent from "@/components/inquiryDetails/inputDataContent";
import ResultContent from "@/components/resultContent";
import { IBaseLabelValue } from "@/interfaces";
import { IRawPurchasedVehicleInfoInquiryResData } from "@/interfaces/inquiries/vehicle";
import { routes } from "@/routes";
import { useRouter } from "next/navigation";

const valueOrDash = (value?: string | number | null) =>
  value === undefined || value === null || value === "" ? "-" : String(value);

const buildPlateText = (input?: Record<string, string | undefined>) => {
  const plateParts = [
    input?.plk_serial,
    input?.plk2,
    input?.plk3,
    input?.plk1,
  ].filter(Boolean);

  return input?.plate_number || (plateParts.length ? plateParts.join(" ") : "-");
};

const VehicleInfoInquiryDetails = ({
  data,
}: {
  data: IRawPurchasedVehicleInfoInquiryResData;
}) => {
  const router = useRouter();
  const storedPayload = (data as any)?.data ?? {};
  const inquiryData = storedPayload?.data ?? storedPayload;
  const inquiryInput =
    storedPayload?.input ?? (data as any).user_input ?? inquiryData?.input ?? {};

  const inputContent: IBaseLabelValue[] = [
    {
      label: "کد ملی مالک",
      value: valueOrDash(inquiryInput?.national_code || inquiryInput?.nationalCode),
    },
    {
      label: "شماره پلاک",
      value: buildPlateText(inquiryInput),
    },
  ];

  const resultContent: IBaseLabelValue[] = [
    {
      label: "نام خودرو",
      value: valueOrDash(inquiryData?.name),
    },
    {
      label: "مدل خودرو",
      value: valueOrDash(inquiryData?.model),
    },
    {
      label: "شماره موتور",
      value: valueOrDash(inquiryData?.engineNumber),
    },
    {
      label: "شماره شاسی",
      value: valueOrDash(inquiryData?.chassisNumber),
    },
    {
      label: "VIN",
      value: valueOrDash(inquiryData?.vin),
    },
  ];

  return (
    <div className="shadow-main from-sky-bliss relative basis-[500px] rounded-2xl bg-linear-to-b to-transparent p-[2px] lg:basis-[640px]">
      <FlexCol className="items-stretch rounded-2xl bg-white p-6 sm:p-8">
        <h2 className="mb-8 text-center font-bold lg:text-lg">
          نتیجه استعلام مشخصات و مدل خودرو
        </h2>

        <InputDataContent
          content={inputContent}
          className="mb-6 p-6 md:p-8"
          itemClassName="flex-col md:flex-row leading-9 md:leading-none"
        />

        <ResultContent content={resultContent} />

        <FlexCenter className="flex flex-col justify-center md:flex-row md:gap-6">
          <CustomButton
            id="details-vehicle-info-back"
            className="w-fit bg-gray-500"
            onClick={() => router.push(routes.main.INQUIRY_HISTORY.primaryPath)}
          >
            بازگشت
          </CustomButton>
          <CustomButton
            id="details-vehicle-info-new-request"
            onClick={() => router.push(routes.services.Vehicle_Info.rewritePath)}
            className="bg-primary-main mx-auto w-fit px-8! text-white"
          >
            استعلام جدید
          </CustomButton>
        </FlexCenter>
      </FlexCol>
    </div>
  );
};

export default VehicleInfoInquiryDetails;
